import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { palette, theme  as colorTheme} from "../../../../Convoze.theme";



function RoleFilter({ value, onChange }) {

    const primary = colorTheme('palette', 'primary').value;


  
  return (
    <FormControl
      size="small"
      sx={{
        minWidth: { xs: "100%", sm: 120 },
        width: { xs: "100%", sm: "auto" },
        "& .MuiOutlinedInput-root": {
          "&:hover fieldset": { borderColor: primary },
          "&.Mui-focused fieldset": { borderColor: primary },
          "& .MuiInputBase-input": { fontSize: 14 },
        },
        "& .MuiInputLabel-root": {
          color: "text.secondary", // default color
          fontSize: 14,
          "&.Mui-focused": {
            // color: "#6366F1", // label color on focus
            color : primary
          },
        },
      }}
    >
      <InputLabel>All Roles</InputLabel>
      <Select
        label="All Roles"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="Admin">Admin</MenuItem>
        <MenuItem value="Manager">Manager</MenuItem>
        <MenuItem value="Agent">Agent</MenuItem>
      </Select>
    </FormControl>
  );
}

export default RoleFilter;
